import {request} from '../jslib/request'
const BASE_REQUEST = '/tms/costAggregation'


export function getIncomeList(contractCompany,routeName,name,pageNo,pageSize,accountType) {
  return request({
    url:`${BASE_REQUEST}/getIncomeList`,
    data: {
      contractCompany:contractCompany,
      routeName:routeName,
      name:name,
      pageNo:pageNo,
      pageSize: pageSize,
      accountType:accountType
    }
  })
}

export function getPaymentList(querydata) {
  return request({
    url:`${BASE_REQUEST}/getPaymentList`,
    data: querydata
  })
}

export function getPaymentListmaipiao(querydata) {
  return request({
    url:`${BASE_REQUEST}/getPaymentListmaipiao`,
    data: querydata
  })
}

export function getPaymentListfandian(querydata) {
  return request({
    url:`${BASE_REQUEST}/getPaymentListfandian`,
    data: querydata
  })
}
export function getIncomeListByCompany(obj) {
  return request({
    url:`${BASE_REQUEST}/getIncomeListByCompany`,
    data: obj
  })
}

export function getPaymentListById(querydata) {
  return request({
    url:`${BASE_REQUEST}/getPaymentListById`,
    data: querydata
  })
}

export function getPaymentDetailListByPage(querydata) {
  return request({
    url:`${BASE_REQUEST}/getPaymentDetailListByPage`,
    data: querydata
  })
}
export function setCostAggReconDate(querydata) {
  return request({
    url:`${BASE_REQUEST}/setCostAggReconDate`,
    data: querydata
  })
}

export function getPaymentfandianListById(querydata) {
  return request({
    url:`${BASE_REQUEST}/getPaymentfandianListById`,
    data: querydata
  })
}

export function getDeductListByCompany(querydata) {
  return request({
    url:`${BASE_REQUEST}/getDeductListByCompany`,
    data: querydata
  })
}

export function getInterTicketList(querydata) {
  return request({
    url:`${BASE_REQUEST}/getInterTicketList`,
    data: querydata
  })
}

export function getInterTicketListById(querydata) {
  return request({
    url:`${BASE_REQUEST}/getInterTicketListById`,
    data: querydata
  })
}

export function getAllMoneyForYear(querydata) {
  return request({
    url: `${BASE_REQUEST}/getAllMoneyForYear`,
    data:querydata
  })
}

export function getInMoneyForYear(querydata) {
  return request({
    url: `${BASE_REQUEST}/getInMoneyForYear`,
    method: 'get',
    data:querydata
  })
}

